import { render } from "./AwardsView.vue?vue&type=template&id=121e9874&scoped=true"
import script from "./AwardsView.vue?vue&type=script&lang=js"
export * from "./AwardsView.vue?vue&type=script&lang=js"

import "./AwardsView.vue?vue&type=style&index=0&id=121e9874&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adoranwodo2.0/adoranwodo2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-121e9874"]])

export default __exports__